import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { NavigationItemLinkModel } from './navigationItem/models/navigationItem.model';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';

const NavigationAccordionLinkItem = (props: { model: NavigationItemLinkModel; closeMainNavigation: () => void }) => {
  const { model, closeMainNavigation } = props;
  return (
    <li className="navigation__accordion-item">
      {/* @todo check if this causes problems in EE*/}
      <RoutableSitecoreLink
        className="navigation__accordion-item__trigger navigation__accordion-item__trigger--link"
        field={model.link}
        onClick={closeMainNavigation}
      >
        <RichText field={model.menuTitle} tag="span" />
      </RoutableSitecoreLink>
    </li>
  );
};

export default NavigationAccordionLinkItem;
